import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Img, Input, Text, Radio, CheckboxCustom } from "components";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as APIS from "../../../../utils/helper/Enum";
// import { updateOrderSummary } from "../../refvdux/reducers/orderSummary";
import * as CARDVALIDATION from "../../../../utils/helper/payfortValidation";
import { getAuth } from "../../../../redux/reducers/loginData";
import { changeTrigger } from "redux/reducers/trigger";
import ApplePayComponent from "../../../ApplePayComponent/index.jsx";
import {
  updateOrderData,
  getOrderData,
} from "../../../../redux/reducers/orderData";

const Payment = ({ orderSummary, orderDetails, isEventSent, setIsEventSent, sendCheckoutGaEvent }) => {
  const [creditCardList, setCreditCardList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const { t } = useTranslation();
  const orderData = useSelector(getOrderData);
  const [cardData, setCardData] = useState({});
  const [cardError, setCardError] = useState({});
  const [tabbyData, setTabbyData] = useState({});
  const [tabbyError, setTabbyError] = useState({});
  const [cardTypeError, setCardTypeError] = useState({});
  const [paymentSending, setPaymentSending] = useState(false);
  const [showSavedCard, setShowSavedCard] = useState(true);
  const [activeTab, setActiveTab] = useState(null);
  const [showApplePayButton, setShowApplePayButton] = useState(false);
  const [applePayDetail, setApplePayDetail] = useState({});
  const [applePayEmail, setApplePayEmail] = useState("");
  const [applePayError, setApplePayError] = useState("");

  const [showNewCardForm, setShowNewCardForm] = useState(false);

  const checkCartType = (cardNo) => {
    let res = CUSTOM.getCardType(cardNo);
    setCardTypeError(res);
  };

  const handleTabClick = (index) => {
    setCardData({});
    setCardError({});
    setTabbyData({});
    setTabbyError({});
    setCardTypeError({});
    if (index === 1111) {
      setShowNewCardForm(false);
    }
    dispatch(updateOrderData({ ...orderData, paymentTabId: index }));
  };

  const sendAddPaymentInfoEvent = () => {
    if (!isEventSent?.addPaymentInfo) {
      setIsEventSent((prev) => ({ ...prev, addPaymentInfo: true }));
      sendCheckoutGaEvent("add_payment_info");
    }
  };

  const sendPurchaseGaEvent = async (order_number) => {
    try {
      let response = await globalRequest(
        APIS?.ORDER?.SEND_PURCHASE_GA_EVENT,
        "post",
        { order_number, gaData: CUSTOM.getGACookieValues() },
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        console.log("GA event sent");
      }
    } catch (e) {
      console.log(e?.message);
    }
  };

  /**
   * send gift payment
   */
  const sendGift = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        APIS?.CUSTOMCAKE?.SENDGIFT,
        "post",
        {
          order_id: orderDetails?.orderData?.id,
          device_type: "web",
          user_details: orderData?.userDetails,
          coupon_code_id: orderData?.couponCodeId ? orderData?.couponCodeId : 0,
          coupon_code: orderData?.couponCode ? orderData?.couponCode : "",
          gift_details: orderData?.buying_for_love,
          additional_notes: orderData?.notes ? orderData?.notes : "",
          order_summary_total_amount: orderSummary?.total_amount,
        },
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        let order_number = response?.data?.orderNumber;
        navigate(`/cart-success/${order_number}`);
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   * get saved card list
   */
  const getCardList = async () => {
    try {
      let response = await globalRequest(
        APIS.USERS.GET_SAVED_CARD_LIST,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setCreditCardList(response?.data);
      } else {
        setCreditCardList([]);
      }
    } catch (e) {
      setCreditCardList([]);
    }
  };

  /**
   * verify cart if valid or not for payment
   */
  const verifyCard = () => {
    const newErrors = {};
    if (!cardData?.token_name) {
      if (cardData.card_number) {
        let resValidation = CARDVALIDATION.validateCard(cardData.card_number);
        if (!resValidation?.validity) {
          newErrors.card_number = t("cardNumberError");
        }
      } else {
        newErrors.card_number = t("cardNumberErrorEmpty");
      }
      if (cardData.expiration_date) {
        if (!CARDVALIDATION.validateExpiryDate(cardData.expiration_date)) {
          newErrors.date = t("cardDateError");
        }
      } else {
        newErrors.date = t("cardDateErrorEmpty");
      }
      if (!cardData.card_holder) {
        newErrors.card_holder = t("cardHolderError");
      } else {
        let cartHolderValidation = CARDVALIDATION.validateHolderName(
          cardData.card_holder
        );
        if (!cartHolderValidation?.validity) {
          newErrors.card_holder = t("cardNumberError");
        }
      }
    }
    if (cardData.cvv) {
      if (!cardData.cvv.match(/^\d{3,4}$/)) {
        newErrors.cvv = t("cvvNumberError");
      }
    } else {
      newErrors.cvv = t("cvvNumberErrorEmpty");
    }

    if (Object.keys(newErrors).length > 0) {
      setCardError(newErrors);
      return false;
    }
    return true;
  };

  const verifyTabbyFields = () => {
    let newErrors = {};
    if (tabbyData?.email) {
      if (!CUSTOM.isValidField(tabbyData?.email, "email")) {
        newErrors.email = t("email_name_required");
      }
    } else {
      newErrors.email = t("email_name_required");
    }

    if (tabbyData?.phone) {
      if (tabbyData?.phone.length != 9) {
        newErrors.phone = t("mobile_no_length_error");
      }
    } else {
      newErrors.phone = t("mobile_no_required");
    }

    if (Object.keys(newErrors).length > 0) {
      setTabbyError(newErrors);
      return false;
    }
    return true;
  };

  /**
   * Pay via wallet
   */
  const payViaWallet = async () => {
    try {
      dispatch(changeLoader(true));
      sendAddPaymentInfoEvent();
      let input = {
        order_id: orderDetails?.orderData?.id,
        branch_id: orderData?.timeSloat?.branchId,
        address_id:
          orderData?.delivery_mode == "home_office"
            ? orderData?.home_office?.itemDetail?.id
            : orderData?.home_office?.id,
        drop_zone_id:
          orderData?.delivery_mode == "pickup_point"
            ? orderData?.home_office?.id
            : 0,
        coupon_code_id: orderData?.couponCodeId ? orderData?.couponCodeId : 0,
        coupon_code: orderData?.couponCode ? orderData?.couponCode : "",
        delivery_mode: CUSTOM.deliveryMethod(orderData?.delivery_mode), //delivery , pickUp , gift
        delivery_type: orderData?.delivery_type, //fastest/schedule
        delivery_date: orderData?.delivery_date,
        delivery_time_slot_id: orderData?.timeSloat?.id || "",
        additional_notes: orderData?.notes,
        payment_method: "wallet",
        wallet_use: orderData?.iswallet,
        device_type: "web",
        order_type: "custom_cake",
        user_details: {
          first_name: orderData?.userDetails?.first_name,
          last_name: orderData?.userDetails?.last_name,
          mobile_no: orderData?.userDetails?.mobile_no,
          email: orderData?.userDetails?.email,
        },
        order_summary_total_amount: orderSummary?.total_amount,
      };
      let response = await globalRequest(
        APIS.CUSTOMCAKE.PAY_PAYMENT,
        "post",
        input,
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        let order_number = response?.data?.order_number;
        sendPurchaseGaEvent(order_number);
        navigate(`/cart-success/${order_number}?type=custom-cake`);
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   *  Pay via card or tabby
   */
  const payViaOtherSource = async (type = "", applePayData, session) => {
    if (type != "apple_pay") {
      if (type == "tabby") {
        if (!verifyTabbyFields()) {
          return;
        }
      } else if (!verifyCard()) {
        return;
      }
    }
    try {
      dispatch(changeLoader(true));
      sendAddPaymentInfoEvent();
      let input = {
        applePayData: applePayData,
        card_security_code: cardData?.token_name ? cardData?.cvv : "",
        order_id: orderDetails?.orderData?.id,
        branch_id: orderData?.timeSloat?.branchId,
        address_id:
          orderData?.delivery_mode == "home_office"
            ? orderData?.home_office?.itemDetail?.id
            : orderData?.home_office?.id,
        drop_zone_id:
          orderData?.delivery_mode == "pickup_point"
            ? orderData?.home_office?.id
            : 0,
        coupon_code_id: orderData?.couponCodeId ? orderData?.couponCodeId : 0,
        coupon_code: orderData?.couponCode ? orderData?.couponCode : "",
        delivery_mode: CUSTOM.deliveryMethod(orderData?.delivery_mode), //delivery , pickUp , gift
        delivery_type: orderData?.delivery_type, //fastest/schedule
        delivery_date: orderData?.delivery_date,
        delivery_time_slot_id: orderData?.timeSloat?.id || "",
        additional_notes: orderData?.notes,
        payment_method:
          type == "tabby"
            ? "tabby"
            : type == "apple_pay"
            ? "apple_pay"
            : "card",
        wallet_use: orderData?.iswallet,
        device_type: "web",
        order_type: "custom_cake",
        user_details: {
          first_name: orderData?.userDetails?.first_name,
          last_name: orderData?.userDetails?.last_name,
          mobile_no: orderData?.userDetails?.mobile_no,
          email: orderData?.userDetails?.email,
        },
        applePayEmail: applePayEmail,
        order_summary_total_amount: orderSummary?.total_amount,
      };
      input = { ...input, ...cardData };
      if (type == "tabby") {
        input.tabby_phone_number = tabbyData?.phone;
        input.tabby_email = tabbyData?.email;
      }
      let response = await globalRequest(
        APIS.CUSTOMCAKE.PAY_PAYMENT,
        "post",
        input,
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(changeTrigger("updateinlocalforcustomcake"));
        if (response?.data?.otp_link) {
          window.location.href = response?.data?.otp_link;
        } else if (response?.data?.is_card === 1) {
          let cData = {
            ...cardData,
            ...response?.data?.cardData,
            is_submit: 1,
          };
          setCardData(cData);
        } else if (response?.data?.is_tabby === 1) {
          let cData = {
            ...tabbyData,
            ...response?.data?.cardData,
            is_submit_tabby: 1,
          };
          setTabbyData(cData);
        } else {
          if (type == "apple_pay") {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
            CUSTOM.sendPaymentStatusGaEvent("success", "order", auth?.id, orderData?.userDetails);
          }
          let order_number = response?.data?.order_number;
          sendPurchaseGaEvent(order_number);
          navigate(`/cart-success/${order_number}`);
        }
      } else {
        if (type == "apple_pay") {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          CUSTOM.sendPaymentStatusGaEvent("failed", "order", auth?.id, orderData?.userDetails);
        }
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    } catch (e) {
      if (type == "apple_pay") {
        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * submit payment form
   */
  const submitPaymentForm = () => {
    let form = document.getElementById("aps_payment_form");
    if (form) {
      form.submit();
    }
  };

  const submitPaymentFormTabby = () => {
    let form = document.getElementById("aps_payment_form_tabby");
    if (form) {
      form.submit();
    }
  };

  const checkApplePayEmail = (email) => {
    if (email) {
      if (!CUSTOM.isValidField(email, "email")) {
        setApplePayError(t("please_enter_valid_email"));
      } else {
        setApplePayError("");
      }
    } else {
      setApplePayError(t("email_name_required"));
    }
  };

  /**
   * set payment tab
   */
  useEffect(() => {
    setActiveTab(orderData?.paymentTabId ? orderData?.paymentTabId : null);
  }, [orderData?.paymentTabId]);

  useEffect(() => {
    getCardList();
  }, []);

  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setShowApplePayButton(true);
    }
  }, []);

  useEffect(() => {
    let intervalId;
    if (paymentSending) {
      intervalId = setInterval(() => {
        let paymentResponse = localStorage.getItem("paymentdata");
        if (paymentResponse) {
          paymentResponse = JSON.parse(paymentResponse);
          if (paymentResponse?.status == "success") {
            sendPurchaseGaEvent(paymentResponse?.order_id);
            CUSTOM.sendPaymentStatusGaEvent("success", "order", auth?.id, orderData?.userDetails);
            navigate(`/cart-success/${paymentResponse?.order_id}`);
          } else {
            CUSTOM.sendPaymentStatusGaEvent("failed", "order", auth?.id, orderData?.userDetails);
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: paymentResponse?.message,
                snackbarState: "error",
              })
            );
          }
          localStorage.removeItem("paymentdata");
          clearInterval(intervalId);
          setPaymentSending(false);
          dispatch(changeLoader(false));
        }
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentSending]);

  useEffect(() => {
    // OLD logic — kept commented for reference
    // let isShow = false;
    // if (orderData?.iswallet) {
    //   if (orderSummary?.wallet_balance < orderSummary?.total_amount) {
    //     isShow = true;
    //   }
    // } else {
    //   isShow = true;
    // }
    // setShowSavedCard(isShow);
    setShowSavedCard(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  useEffect(() => {
    if (tabbyData?.is_submit_tabby) {
      submitPaymentFormTabby();
    }
  }, [tabbyData]);

  useEffect(() => {
    if (cardData?.is_submit) {
      submitPaymentForm();
    }
  }, [cardData]);

  useEffect(() => {
    let edate = "";
    if (cardData?.expiration_date) {
      let expdata = cardData?.expiration_date.split("/");
      if (expdata.length > 1) {
        edate = `${expdata[1]}${expdata[0]}`;
      }
    }
    setCardData({ ...cardData, edate: edate });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardData?.expiration_date]);

  useEffect(() => {
    let applePayDataObj = {};
    if (orderData?.iswallet) {
      applePayDataObj.amount = CUSTOM.setPrice(
        orderSummary?.total_amount - orderSummary?.wallet_balance
      );
    } else {
      applePayDataObj.amount = CUSTOM.setPrice(orderSummary?.total_amount);
    }
    setApplePayDetail(applePayDataObj);
  }, [orderData, orderSummary]);

  return (
    <>
      {showSavedCard ? (
        <>
          <form
            method="post"
            action={`${
              process.env.REACT_APP_PAYFORT_MODE == "TEST"
                ? process.env.REACT_APP_PAYFORT_DEVLOPMENT
                : process.env.REACT_APP_PAYFORT_PRODUCTION
            }/FortAPI/paymentPage`}
            id="aps_payment_form"
            name="aps_payment_form"
            className="hidden"
          >
            <span
              dangerouslySetInnerHTML={{
                __html: CUSTOM.paymentFormHtml(cardData),
              }}
            ></span>
          </form>
          <form
            method="post"
            action={`${
              process.env.REACT_APP_PAYFORT_MODE == "TEST"
                ? process.env.REACT_APP_PAYFORT_DEVLOPMENT
                : process.env.REACT_APP_PAYFORT_PRODUCTION
            }/FortAPI/paymentPage`}
            id="aps_payment_form_tabby"
            name="aps_payment_form_tabby"
            className="hidden"
          >
            <span
              dangerouslySetInnerHTML={{
                __html: CUSTOM.paymentFormHtmlTabby(tabbyData),
              }}
            ></span>
          </form>
        </>
      ) : null}

      <div className="relative flex flex-col w-full bg-white">

        {/* ── Header — Cart style: Unbounded font ── */}
        {/* OLD header kept commented:
        <div className="flex flex-row xs:flex-col xs:items-start gap-4 items-center justify-between w-full mb-4 px-6 xs:px-4">
          <div className="flex flex-col gap-1 items-start justify-start flex-1">
            <Text className="text-base text-black-900 font-nunitomedium">
              {t("payment")}
            </Text>
            <div className="flex gap-1 flex-row items-center">
              <Text className="text-black-900 text-sm font-nunitoregular">
                {t("selectAnOptionToPay")}
              </Text>
            </div>
          </div>
          {orderData?.pageStep > 3 ? (
            <Text className="w-auto text-base text-black-900 font-nunitomedium whitespace-nowrap">
              {t("sar")} {CUSTOM.setPrice(orderSummary?.total_amount)}
            </Text>
          ) : null}
        </div>
        */}
        <div className="flex flex-row xs:flex-col xs:items-start gap-4 items-center justify-between w-full mb-6 px-6 xs:px-4">
          <div className="flex flex-col gap-1 items-start justify-start flex-1">
            <Text
              className="
                text-[24px] leading-[32px] font-medium text-[#1A1A1A]
                font-['Unbounded']
                sm:text-[20px] sm:leading-[28px] sm:font-normal
              "
            >
              {t("paymentsMethods")}
            </Text>
          </div>
        </div>

        {/* ── Non-gift payment section ── */}
        {orderData?.pageStep > 3 &&
        orderData?.delivery_mode != "buying_for_love" ? (
          <div className="flex flex-col items-center justify-between w-full px-6 xs:px-4">

            {/* OLD wallet section (checkbox style) — kept commented:
            {auth?.id > 0 ? (
              <>
                <div className="flex flex-row items-start justify-start w-full pb-3.5 border-b ">
                  <CheckboxCustom
                    checked={orderData?.iswallet == 1}
                    disabled={orderSummary?.wallet_balance == 0 || !orderSummary?.wallet_balance}
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(updateOrderData({ ...orderData, iswallet: 1 }));
                      } else {
                        dispatch(updateOrderData({ ...orderData, iswallet: 0 }));
                      }
                    }}
                  />
                  <div className="flex flex-col items-start justify-start flex-1 -ml-4 rtl:ml-0 rtl:-mr-4 mt-2">
                    <Text className="text-base text-black-900 font-nunitoregular">{t("wallet")}</Text>
                    <div className="flex flex-row xs:flex-col gap-1 items-start justify-start flex-1">
                      <Text className="text-gray-700 text-sm font-nunitoregular">{t("availableBalance")}</Text>
                      <Text className="text-black-900 text-sm font-nunitomedium">
                        {t("sar")} {CUSTOM.setPrice(orderSummary?.wallet_balance)}
                      </Text>
                    </div>
                    {orderData?.iswallet && !showSavedCard ? (
                      <div className="w-full mt-3 max-w-[242px]">
                        <Button className="flex-1 mx-auto xs:w-full" size="lg" variant="FillBlack"
                          onClick={(e) => { payViaWallet(); }}>
                          {t("payNow")} {t("sar")} ({CUSTOM.setPrice(orderSummary?.total_amount)})
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </>
            ) : null}
            */}

            {showSavedCard ? (
              <>
                {/* Pay remaining amount label — only when wallet is active */}
                {orderData?.iswallet ? (
                  <div className="flex flex-row gap-4 items-center justify-between w-full mb-4 pb-4 border-b">
                    <Text className="text-base text-black-900 font-['Inter']">
                      {t("payRemainingAmountWith")}
                    </Text>
                    <Text className="w-auto text-base text-black-900 font-['Inter'] whitespace-nowrap">
                      {t("sar")}{" "}
                      {CUSTOM.setPrice(
                        orderSummary?.total_amount - orderSummary?.wallet_balance
                      )}
                    </Text>
                  </div>
                ) : null}

                {/* ── Payment Method Cards Grid — Cart style ── */}
                {/* OLD individual tab rows kept commented:
                {creditCardList?.map((items, indexs) => {
                  indexs = indexs + 2;
                  return (
                    <div className="common-pointer flex flex-row gap-3 items-start justify-start w-full pb-3.5 border-b mt-2" isSelected={activeTab === indexs}>
                      <Radio name="paymentMode" checked={activeTab === indexs} onChange={() => handleTabClick(indexs)} />
                      ...
                    </div>
                  );
                })}
                <div className="common-pointer flex flex-row gap-3 items-start justify-start w-full pt-5 pb-5 border-b" isSelected={activeTab === 1111}>
                  <Radio name="paymentMode" checked={activeTab === 1111} onChange={() => handleTabClick(1111)} />
                  ...creditDebitCard form...
                </div>
                <div className="common-pointer flex flex-row gap-3 ..." isSelected={activeTab === 2222}>
                  ...tabby form...
                </div>
                */}

                <div className="grid grid-cols-2 xs:grid-cols-1 gap-4 w-full mb-6">

                  {/* Credit/Debit Card tile */}
                  <div
                    className={`common-pointer flex flex-col p-4 border rounded-lg cursor-pointer ${
                      activeTab === 1111 || (activeTab >= 2 && activeTab < 2222)
                        ? "border-black-900"
                        : "border-gray-300"
                    }`}
                    onClick={() => handleTabClick(1111)}
                  >
                    <div className="flex flex-col gap-3 items-start justify-start w-full">
                      <div className="flex flex-row justify-between w-full">
                        <div className="w-[50%] flex justify-start">
                          <Text className="text-[16px] leading-[24px] font-semibold text-[#1A1A1A] font-['Inter']">
                            {t("creditDebitCard")}
                          </Text>
                        </div>
                        <div className="w-[50%] flex justify-end">
                          <Radio
                            name="paymentMode"
                            checked={activeTab === 1111 || (activeTab >= 2 && activeTab < 2222)}
                            onChange={() => handleTabClick(1111)}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col items-start gap-2 justify-start flex-1">
                        <div className="flex flex-row gap-2 items-center justify-start flex-wrap">
                          <Text className="text-[14px] leading-[24px] font-normal text-[#727783] font-['Inter']">
                            Accepted Methods
                          </Text>
                          <Img className="h-8 w-8" src="/images/Encapsulated.svg" alt="mada" />
                          <Img className="h-8 w-8" src="/images/paymentApple.svg" alt="apple" />
                          <Img className="h-5 w-5" src="/images/Mastercard.svg" alt="mastercard" />
                          <Img className="h-6 w-8" src="/images/paymentVisa.svg" alt="visa" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Tabby tile */}
                  <div
                    className={`common-pointer flex flex-col p-4 border rounded-lg cursor-pointer ${
                      activeTab === 2222
                        ? "border-black-900 bg-gray-50"
                        : "border-gray-300"
                    }`}
                    onClick={() => handleTabClick(2222)}
                  >
                    <div className="flex flex-row justify-between w-full">
                      <div className="w-[50%] flex justify-start">
                        <Text className="text-[16px] leading-[24px] font-semibold text-[#1A1A1A] font-['Inter']">
                          {t("payWithTabby")}
                        </Text>
                      </div>
                      <div className="w-[50%] flex justify-end">
                        <Radio
                          name="paymentMode"
                          checked={activeTab === 2222}
                          onChange={() => handleTabClick(2222)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-row items-start gap-2 justify-between pt-3 flex-1">
                      <Text className="text-[14px] leading-[24px] font-normal text-[#727783] font-['Inter']">
                        You will be redirected to Tabby
                      </Text>
                      <Text className="bg-[#3ECFA0] text-white text-xs px-2 py-1 rounded font-semibold">
                        tabby
                      </Text>
                    </div>
                  </div>
                </div>

                {/* ── Wallet toggle — Cart style ── */}
                {auth?.id > 0 ? (
                  <div className="w-full mb-4 rounded-lg bg-white p-3 sm:p-0 sm:rounded-none sm:bg-transparent sm:border-b sm:pb-4">
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex flex-col flex-1">
                        <Text className="text-[14px] leading-[20px] font-medium text-[#1A1A1A] font-['Inter'] sm:text-[16px] sm:leading-[24px]">
                          Pay {t("sar")}
                          <Img className="inline h-4 w-4 mx-1" src="/images/Groupsar2.svg" />
                          <span className="font-['Unbounded']">
                            {CUSTOM.setPrice(orderSummary?.total_amount)}
                          </span>{" "}
                          from wallet balance.
                        </Text>
                        <Text className="text-[14px] leading-[20px] text-[#727783] font-['Inter']">
                          {t("availableBalance")} (
                          <span className="inline-flex items-center gap-1">
                            {t("sar")}
                            <Img className="h-3 w-3" src="/images/Groupsar1.svg" alt="wallet" />
                            {CUSTOM.setPrice(orderSummary?.wallet_balance)}
                          </span>
                          )
                        </Text>
                      </div>
                      {/* Toggle switch */}
                      <div className="flex items-center">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={orderData?.iswallet == 1}
                            disabled={
                              orderSummary?.wallet_balance == 0 ||
                              !orderSummary?.wallet_balance
                            }
                            onChange={(e) => {
                              dispatch(
                                updateOrderData({
                                  ...orderData,
                                  iswallet: e.target.checked ? 1 : 0,
                                })
                              );
                            }}
                          />
                          <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#4CAF50]"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* ── Saved Cards + New Card Form — Cart style ── */}
                {(activeTab === 1111 || (activeTab >= 2 && activeTab < 2222)) ? (
                  <div className="flex flex-col items-start justify-start w-full p-4 rounded-lg border border-gray-300 mb-4">
                    {!showNewCardForm && (
                      <Text className="text-[#1A1A1A] font-['Inter'] text-[20px] leading-[28px] font-medium sm:text-[16px] mb-4">
                        Saved Cards
                      </Text>
                    )}

                    {/* Saved Cards List */}
                    {creditCardList?.length > 0 && !showNewCardForm && (
                      <div className="w-full mb-4 space-y-3">
                        {creditCardList.map((items, indexs) => {
                          const savedCardIndex = indexs + 2;
                          return (
                            <div
                              key={indexs}
                              className={`common-pointer flex flex-row gap-3 items-start justify-start w-full p-3 border rounded-lg ${
                                activeTab === savedCardIndex
                                  ? "border-black-900 bg-white"
                                  : "border-gray-300 bg-white"
                              }`}
                              onClick={() => handleTabClick(savedCardIndex)}
                            >
                              <Radio
                                name="savedCard"
                                checked={activeTab === savedCardIndex}
                                onChange={() => handleTabClick(savedCardIndex)}
                              />
                              <div className="flex flex-col items-start justify-start flex-1">
                                <div className="flex flex-row gap-2 items-center justify-between w-full">
                                  <Text className="text-sm font-medium text-black-900 font-['Inter']">
                                    {items?.type} •••• {items?.cardNumber}
                                  </Text>
                                  <Img
                                    className="h-6"
                                    src={CUSTOM.cardTypeLogo(items?.type)}
                                    alt={items?.type}
                                  />
                                </div>
                                {activeTab === savedCardIndex && (
                                  <div className="max-w-[280px] w-full mt-3">
                                    <Input
                                      required
                                      label={t("cvv")}
                                      type="password"
                                      value={cardData?.cvv}
                                      error={cardError?.cvv}
                                      onChange={(e) => {
                                        setCardData({
                                          ...cardData,
                                          token_name: items?.cardToken,
                                          cvv: CUSTOM.strFormat(
                                            e.target.value,
                                            "max:4|number"
                                          ),
                                        });
                                        setCardError({ ...cardError, cvv: "" });
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Add New Card button */}
                    {!showNewCardForm && (
                      <button
                        className="w-full border border-gray-300 rounded-lg p-2 mt-2 text-center hover:border-black-900 transition-colors"
                        onClick={() => setShowNewCardForm(true)}
                      >
                        <Text className="w-full h-[46px] px-[40px] py-[12px] flex items-center justify-center gap-[10px] rounded-[360px] border border-gray-600 text-black-900 text-[16px] leading-[24px] font-medium font-['Unbounded'] text-center sm:text-[14px] sm:leading-[20px]">
                          + Add New Card
                        </Text>
                      </button>
                    )}

                    {/* New Card Form — Cart style */}
                    {/* OLD new card form kept commented:
                    {activeTab == 1111 ? (
                      <div className="hidden111 max-w-[580px] w-full flex flex-col items-start justify-start mt-6 mb-[18px]">
                        <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-5">
                          <TextField required label={t("cardNumber")} ... />
                          <TextField required label={t("cardHolderName")} ... />
                        </div>
                        <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-5">
                          <TextField required label={t("expiryDate(MM/YY)")} ... />
                          <TextField required label={t("cvv")} type="password" ... />
                        </div>
                        ...
                        <Button ... onClick={(e) => { payViaOtherSource(); }}>{t("payNow")}</Button>
                      </div>
                    ) : null}
                    */}
                    {showNewCardForm && (
                      <div className="w-full flex flex-col items-start justify-start bg-white p-4 rounded-lg">
                        <Text className="text-[#1A1A1A] font-['Inter'] text-[20px] leading-[28px] font-medium mb-4 sm:text-[16px] sm:leading-[24px] sm:font-semibold">
                          {t("addingNewCard") || "Add New Card"}
                        </Text>

                        {/* Card Holder Name */}
                        <div className="flex flex-col gap-1 w-full mb-3">
                          <Text className="text-[#6D737E] font-['Inter'] text-[14px] leading-[16px] font-medium">
                            {t("cardHolderName")} <span className="text-red-500">*</span>
                          </Text>
                          <TextField
                            placeholder="Enter your card name"
                            value={cardData?.card_holder}
                            error={!!cardError?.card_holder}
                            helperText={cardError?.card_holder || " "}
                            onChange={(e) => {
                              setCardData({
                                ...cardData,
                                card_holder: CUSTOM.strFormat(e.target.value, "text|max:50"),
                              });
                              setCardError({ ...cardError, card_holder: "" });
                            }}
                            InputProps={{ className: "h-[48px] rounded-lg" }}
                          />
                        </div>

                        {/* Card Number */}
                        <div className="flex flex-col gap-1 w-full mb-3">
                          <Text className="text-[#6D737E] font-['Inter'] text-[14px] leading-[16px] font-medium">
                            {t("cardNumber")} <span className="text-red-500">*</span>
                          </Text>
                          <TextField
                            placeholder="XXXX XXXX XXXX XXXX"
                            value={cardData?.card_number}
                            error={!!cardError?.card_number}
                            helperText={cardError?.card_number || " "}
                            onChange={(e) => {
                              checkCartType(e.target.value);
                              setCardData({
                                ...cardData,
                                card_number: CUSTOM.strFormat(e.target.value, "number|max:16"),
                              });
                              setCardError({ ...cardError, card_number: "" });
                            }}
                            InputProps={{
                              className: "h-[48px] rounded-lg",
                              endAdornment: cardTypeError?.image && (
                                <img
                                  src={cardTypeError?.image}
                                  className="h-5 rtl:ml-3 card-type-img-in-card-no"
                                  alt="Card Type"
                                />
                              ),
                            }}
                          />
                        </div>

                        <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full">
                          {/* Expiry */}
                          <div className="flex flex-col gap-1">
                            <Text className="text-[#6D737E] font-['Inter'] text-[14px] leading-[16px] font-medium">
                              {t("expiryDate(MM/YY)")} <span className="text-red-500">*</span>
                            </Text>
                            <TextField
                              placeholder="MM/YY"
                              value={cardData?.expiration_date || ""}
                              error={!!cardError?.date}
                              helperText={cardError?.date || " "}
                              onChange={(e) => {
                                setCardData({
                                  ...cardData,
                                  expiration_date: CUSTOM.strFormat(
                                    e.target.value,
                                    "max:15|expiry_date"
                                  ),
                                });
                                setCardError({ ...cardError, date: "" });
                              }}
                              InputProps={{ className: "h-[48px] rounded-lg" }}
                            />
                          </div>

                          {/* CVV */}
                          <div className="flex flex-col gap-1">
                            <Text className="text-[#6D737E] font-['Inter'] text-[14px] leading-[16px] font-medium">
                              {t("cvv")} <span className="text-red-500">*</span>
                            </Text>
                            <TextField
                              type="password"
                              placeholder="***"
                              value={cardData?.cvv}
                              error={!!cardError?.cvv}
                              helperText={cardError?.cvv || " "}
                              onChange={(e) => {
                                setCardData({
                                  ...cardData,
                                  cvv: CUSTOM.strFormat(e.target.value, "max:4|number"),
                                });
                                setCardError({ ...cardError, cvv: "" });
                              }}
                              InputProps={{ className: "h-[48px] rounded-lg" }}
                            />
                          </div>
                        </div>

                        {auth?.id > 0 ? (
                          <div className="flex items-center justify-start w-full -mt-3">
                            <CheckboxCustom
                              checked={cardData?.remember_me == "YES"}
                              onChange={(e) => {
                                setCardData({
                                  ...cardData,
                                  remember_me: e.target.checked ? "YES" : "NO",
                                });
                              }}
                            />
                            <Text className="text-[#1A1A1A] font-['Inter'] text-[14px] font-medium leading-[20px] -ml-4 rtl:ml-0 rtl:-mr-4 -mt-1">
                              {t("saveCardDetailsForFuturePurpose")}
                            </Text>
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                ) : null}

                {/* ── Tabby form — Cart style ── */}
                {/* OLD tabby section kept commented:
                <div className="common-pointer flex flex-row gap-3 items-start justify-start w-full pt-5 pb-5 border-b" isSelected={activeTab === 2222}>
                  <Radio name="paymentMode" checked={activeTab === 2222} onChange={() => handleTabClick(2222)} />
                  ...tabby fields...
                  <Button ... onClick={(e) => { payViaOtherSource("tabby"); }}>{t("payNow")}</Button>
                </div>
                */}
                {activeTab == 2222 ? (
                  <div className="flex flex-col items-start justify-start w-full p-4 rounded-lg mb-4 border border-gray-300">
                    <Text className="text-base font-semibold text-black-900 font-['Inter'] mb-4">
                      Tabby Payment Details
                    </Text>
                    <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full">
                      <TextField
                        required
                        label={t("Phone")}
                        type="text"
                        value={tabbyData?.phone}
                        error={!!tabbyError?.phone}
                        helperText={tabbyError?.phone || " "}
                        onChange={(e) => {
                          setTabbyData({
                            ...tabbyData,
                            phone: CUSTOM.strFormat(e.target.value, "max:9|number"),
                          });
                          setTabbyError({ ...tabbyError, phone: "" });
                        }}
                      />
                      <TextField
                        required
                        label={t("Email")}
                        type="text"
                        value={tabbyData?.email}
                        error={!!tabbyError?.email}
                        helperText={tabbyError?.email || " "}
                        onChange={(e) => {
                          setTabbyData({
                            ...tabbyData,
                            email: CUSTOM.strFormat(e.target.value, "max:50|email"),
                          });
                          setTabbyError({ ...tabbyError, email: "" });
                        }}
                      />
                    </div>
                  </div>
                ) : null}

                {/* Apple Pay — original structure kept */}
                {!!showApplePayButton && (
                  <div
                    className="common-pointer flex flex-row gap-3 items-start justify-start w-full pt-5 pb-5 border-b"
                    isSelected={activeTab === 3333}
                  >
                    <Radio
                      className="flex"
                      name="paymentMode"
                      checked={activeTab === 3333}
                      onChange={() => handleTabClick(3333)}
                    />
                    <div className="flex flex-col items-start gap-1 justify-start flex-1 -mt-1">
                      <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-0 w-full mb-0">
                        <Text className="text-base text-black-900 font-['Inter']">
                          {"Pay with Apple Pay"}
                        </Text>
                      </div>
                      {activeTab == 3333 ? (
                        <div className="hidden111 max-w-[580px] w-full flex flex-col items-start justify-start mt-6 mb-[18px]">
                          {!auth?.email ? (
                            <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-2">
                              <TextField
                                required
                                label={t("Email")}
                                type="text"
                                value={applePayEmail}
                                error={!!applePayError}
                                helperText={applePayError || " "}
                                onChange={(e) => {
                                  let email = CUSTOM.strFormat(
                                    e.target.value,
                                    "max:50|email"
                                  );
                                  setApplePayEmail(email);
                                  checkApplePayEmail(email);
                                }}
                              />
                            </div>
                          ) : null}
                          <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-2">
                            <ApplePayComponent
                              applePayData={applePayDetail}
                              payViaOtherSource={payViaOtherSource}
                              isApplePayEnabled={
                                auth?.email || (applePayEmail && !applePayError)
                              }
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}

                {/* ── Common Pay Now button — Cart style: rounded-full #771237 ── */}
                {/* OLD separate pay buttons kept commented:
                <div className="w-full max-w-[242px] mt-5">
                  <Button className="flex-1 mx-auto" size="lg" variant="FillBlack"
                    onClick={(e) => { payViaOtherSource(); }}>
                    {t("payNow")} (SAR {CUSTOM.setPrice(orderSummary?.total_amount)})
                  </Button>
                </div>
                // Tabby pay button:
                <div className="w-full max-w-[242px] mt-5">
                  <Button className="flex-1 mx-auto" size="lg" variant="FillBlack"
                    onClick={(e) => { payViaOtherSource("tabby"); }}>
                    {t("payNow")} (SAR {CUSTOM.setPrice(orderSummary?.total_amount)})
                  </Button>
                </div>
                // Wallet pay button:
                {orderData?.iswallet && !showSavedCard ? (
                  <div className="w-full mt-3 max-w-[242px]">
                    <Button className="flex-1 mx-auto xs:w-full" size="lg" variant="FillBlack"
                      onClick={(e) => { payViaWallet(); }}>
                      {t("payNow")} {t("sar")} ({CUSTOM.setPrice(orderSummary?.total_amount)})
                    </Button>
                  </div>
                ) : null}
                */}
                <div className="w-full mt-2">
                  <Button
                    className="w-full h-[56px] px-[40px] py-[12px] flex items-center justify-center gap-[10px] rounded-[360px] bg-[#771237] hover:bg-[#771237] text-white text-[16px] leading-[24px] font-medium font-['Unbounded'] text-center"
                    size="lg"
                    variant="FillBlack"
                    onClick={() => {
                      // Wallet has first priority
                      if (
                        orderData?.iswallet == 1 &&
                        orderSummary?.wallet_balance >= orderSummary?.total_amount
                      ) {
                        payViaWallet();
                        return;
                      }
                      if (activeTab === 2222) {
                        payViaOtherSource("tabby");
                      } else if (activeTab === 1111 || (activeTab >= 2 && activeTab < 2222)) {
                        payViaOtherSource();
                      }
                    }}
                    disabled={
                      !(
                        orderData?.iswallet == 1 &&
                        orderSummary?.wallet_balance >= orderSummary?.total_amount
                      ) &&
                      (
                        !activeTab ||
                        activeTab === 0 ||
                        (activeTab >= 2 && activeTab < 2222 && !cardData?.cvv)
                      )
                    }
                  >
                    Pay &nbsp;
                    <Img className="h-4 w-4" src="/images/sarWhite.svg" alt="SAR" />
                    &nbsp;
                    <span>{CUSTOM.setPrice(orderSummary?.total_amount)}</span>
                  </Button>
                  <div className="flex items-center justify-center mt-2 mb-4">
                    <Img className="h-4 w-4 mr-1" src="/images/img_shielddone.svg" alt="secure" />
                    <Text className="text-xs text-black-900 font-['Inter']">
                      {t("100SecurePaymentsPoweredByRabbitHole")}
                    </Text>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        ) : null}

        {/* ── Gift payment section (buying_for_love) — Cart style ── */}
        {/* OLD gift section kept commented:
        {orderData?.pageStep > 3 && orderData?.delivery_mode == "buying_for_love" ? (
          <div className="px-6 xs:px-4">
            <div className="common-pointer bg-light_blue-50 flex flex-col items-center justify-start py-3 px-6 xs:px-3 w-full rounded mt-6">
              <div className="flex flex-row items-center justify-between w-full gap-x-10 gap-y-3 xs:flex-col xs:items-start">
                <div className="flex flex-col flex-1 w-full gap-3 items-start justify-start">
                  <Text className="text-black-900 text-sm font-nunitoregular">
                    {t("thePaymentWillBeRequestedByThePlatformOnceTheRecipientConfirmsTheDetailsYouWillBeNotifiedForTheSame")}
                  </Text>
                  <Text className="text-black-900 text-sm font-nunitoregular">
                    {t("onceTheRecipientHasConfirmedTheDetailsYouHave30MinutesToMakePaymentAndConfirmThisOrderOtherwiseItWillBeCancelled")}
                  </Text>
                </div>
                <Button className="w-auto mx-auto text-base py-[11px] px-[24px] xs:mx-0" size="lg"
                  variant="FillBlack" hover={true} hoverclass="bg-light_blue-50"
                  onClick={(e) => {
                    CUSTOM.trackGiftCheckout({ transaction_id: orderData?.order_id || "N/A", gift_type: orderData?.gift_type || "Not Specified", revenue: orderData?.total_amount || 0 });
                    sendGift();
                  }}>
                  {t("sendGift")}
                </Button>
              </div>
            </div>
          </div>
        ) : null}
        */}
        {orderData?.pageStep > 3 &&
        orderData?.delivery_mode == "buying_for_love" ? (
          <div className="px-6 xs:px-4 pb-6">
            <h2
              className="text-[20px] font-medium leading-[28px] mb-4 text-[#1A1A1A] font-['Inter']"
            >
              {t("giftInformation") || "Gift Information"}
            </h2>

            {/* Info banners — Cart style: pink bg + noteRemark icon */}
            <div className="flex flex-row items-start gap-3 bg-[#FFF0F4] border border-[#F7C5D2] rounded-lg px-4 py-3 mb-3">
              <Img src="/images/noteRemark.svg" alt="note" className="h-6 w-6 mt-0.5 shrink-0" />
              <p className="text-[13px] leading-[20px] text-gray-800 font-['Inter']">
                {t("thePaymentWillBeRequestedByThePlatformOnceTheRecipientConfirmsTheDetailsYouWillBeNotifiedForTheSame")}
              </p>
            </div>

            <div className="flex flex-row items-start gap-3 bg-[#FFF0F4] border border-[#F7C5D2] rounded-lg px-4 py-3 mb-6">
              <Img src="/images/noteRemark.svg" alt="note" className="h-6 w-6 mt-0.5 shrink-0" />
              <p className="text-[13px] leading-[20px] text-gray-800 font-['Inter']">
                {t("onceTheRecipientHasConfirmedTheDetailsYouHave30MinutesToMakePaymentAndConfirmThisOrderOtherwiseItWillBeCancelled")}
              </p>
            </div>

            {/* Send Gift button — Cart style: rounded-xl #771237 */}
            <button
              type="button"
              className="w-full h-[52px] rounded-xl bg-[#771237] text-white text-[16px] font-semibold font-['Unbounded'] hover:bg-[#5e0e2c] transition-colors cursor-pointer shadow-md"
              onClick={() => {
                CUSTOM.trackGiftCheckout({
                  transaction_id: orderData?.order_id || "N/A",
                  gift_type: orderData?.gift_type || "Not Specified",
                  revenue: orderData?.total_amount || 0,
                });
                sendGift();
              }}
            >
              {t("sendGift")}
            </button>
          </div>
        ) : null}

        {/* OLD secure payment banner kept commented:
        <div className="bg-red-50_01 flex md:flex-col flex-row md:gap-5 items-center justify-between py-[22px] px-[30px] xs:p-5 mt-7 w-full">
          <div className="flex flex-1 flex-row gap-3 items-center justify-start w-full">
            <Img className="h-9 w-9" src="/images/img_shielddone.svg" alt="shielddone" />
            <div className="flex flex-col gap-1 items-start justify-start">
              <Text className="text-base text-black-900 font-nunitomedium">{t("secureCardPayment")}</Text>
              <Text className="text-black-900 text-xs font-nunitoregular">{t("100SecurePaymentsPoweredByRabbitHole")}</Text>
            </div>
          </div>
          <div className="gap-2 grid grid-cols-4 w-auto">
            <div className="flex flex-col items-center justify-start w-full">
              <div className="h-8 w-[44px] bg-white-A700 rounded-md">
                <Img className="h-full w-full object-contain" src="/images/img_file_white_a700.svg" alt="file" />
              </div>
            </div>
            <div className="flex flex-col items-center justify-start w-full">
              <div className="h-8 w-[44px] bg-white-A700 rounded-md">
                <Img className="h-full w-full object-contain" src="/images/img_023mastercard1.png" alt="023mastercardOne" />
              </div>
            </div>
            <div className="flex flex-col items-center justify-start w-full">
              <div className="h-8 w-[44px] bg-white-A700 rounded-md">
                <Img className="h-full w-full object-contain" src="/images/img_007visa.png" alt="007visa" />
              </div>
            </div>
            <div className="flex flex-col items-center justify-start w-full">
              <div className="h-8 w-[44px] bg-white-A700 rounded-md">
                <Img className="h-full w-full object-contain" src="/images/img_1200pxrupaysvg.png" alt="1200pxrupaysvg" />
              </div>
            </div>
          </div>
        </div>
        */}

      </div>
    </>
  );
};

export default Payment;
